import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="text-xl font-semibold text-foreground-950 whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
              裸肌研究所
            </Link>
            <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
              回归本真，唤醒肌肤自愈力。<br />用科学的态度、极简的方法，找到最适合你的护肤方案。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">内容分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/jijian-hufu" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">极简护肤</Link>
              <Link to="/category/luoji-yanghu" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">裸肌养护</Link>
              <Link to="/category/suyan-jiqiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">素颜技巧</Link>
              <Link to="/category/chengfen-jiexi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">成分解析</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">更多内容</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/hufu-wuqu" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">护肤误区</Link>
              <Link to="/category/jijie-hufu" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">季节护肤</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">品牌介绍</Link>
              <a href="mailto:hello@jjchuang.cn" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">联系我们</a>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; {currentYear} 裸肌研究所 Bare Skin Lab. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}